import type { Response } from './index';
import { echossAxios } from './index';

interface SerialRedeemApiResponse<T> {
  success: boolean;
  message: string;
  error_code?: string;
  data: T;
}

export interface SerialRedeemResult {
  code: string;
  activity_name: string;
  reward_type: 'coupon' | 'point' | 'gift';
  reward_display: {
    name: string;
    quantity: number;
  };
  destination: 'coupon_wallet' | 'point_card';
  replayed: boolean;
}

export const redeemSerial = async (
  token: string,
  code: string,
): Promise<Response<SerialRedeemResult>> => {
  try {
    const { data } = await echossAxios.request<
      SerialRedeemApiResponse<SerialRedeemResult>
    >({
      url: '/api/member/serial-management/redeem',
      method: 'POST',
      data: { code },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { data: data.data, message: data.message };
  } catch (error: unknown) {
    return {
      error: error as NonNullable<Response<SerialRedeemResult>['error']>,
      data: undefined,
    };
  }
};
